
<Spinner :size="size" :color="color" :centered="centered" />
